import { fetchMergedProvinces } from "api/interna-api";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchCitiesOnError,
  fetchCitiesOnSuccess,
  REQUEST_FETCH_CITIES,
} from "redux/actions/general/cities";

// function* fetchCitiesFlow({ countryId }: AnyAction) {
//   try {
//     const data = yield call(fetchCities, countryId);
//     yield put(fetchCitiesOnSuccess(data));
//   } catch (error) {
//     yield put(fetchCitiesOnError(error));
//   }
// }

function* fetchCitiesFlow() {
  try {
    const data = yield call(fetchMergedProvinces);
    yield put(fetchCitiesOnSuccess(data));
  } catch (error) {
    yield put(fetchCitiesOnError(error));
  }
}

export default function* watchFetchCitiesSaga() {
  yield takeLatest(REQUEST_FETCH_CITIES, fetchCitiesFlow);
}
